import React, { useState, useContext } from 'react'
import {
	Button,
	Card,
	CardBody,
	Col,
	FormGroup,
	Input,
	Label,
	Modal,
	Row
} from 'reactstrap'
import { SpinnerComponent } from 'react-element-spinner'

import { trigger } from '../../events/customEvents'
import AuctionTabsService from '../../services/AuctionTabsService'
import SiteService from '../../services/SiteService'
import { SessionContext } from '../../contexts/SessionProvider'

const VoidSaleModal = ({ isOpen = false, auction = null, onClose, onSuccess }) =>
{
	const [isModalBusy, setIsModalBusy] = useState(false)
	const [voidReason, setVoidReason] = useState('')
	const sessionContext = useContext(SessionContext)

	const handleCancelModal = () =>
	{
		setVoidReason('')
		if (typeof onClose === 'function')
		{
			onClose()
		}
	}

	const handleVoidSale = () =>
	{
		if (!voidReason.trim())
		{
			trigger('raiseNotification', { title: 'Validation', message: 'Please enter a reason for voiding the sale.', type: 'warning', duration: 5 })
			return
		}

		setIsModalBusy(true)
		AuctionTabsService
			.voidSale(auction.auctionId, voidReason.trim(), true, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsModalBusy(false)
				setVoidReason('')
				sessionContext.updateSession(result.data.loginSession)

				trigger('raiseNotification', { title: 'Sale Voided', message: 'The sale has been voided successfully.', type: 'success', duration: 5 })
				if (typeof onSuccess === 'function')
				{
					onSuccess()
				}
			})
			.catch((error) =>
			{
				setIsModalBusy(false)
				SiteService.displayApiError(error)
			})
	}

	// Get VIN for BRD mockup format
	const vin = auction?.vin || auction?.vehicleVin || ''

	return (
		<Modal
			className="modal-dialog-centered"
			size="md"
			isOpen={isOpen}
		>
			<SpinnerComponent
				loading={isModalBusy}
				position="centered"
				message="Processing..."
			/>
			<Card className="mb-0">
				<CardBody>
					{/* BRD: Title shows VIN */}
					<div className="text-muted mb-3">
						<strong>VIN:{vin}</strong>
					</div>
					
					{/* BRD: Simple confirmation message */}
					<p className="mb-2">
						Are you sure you want to void the sale for this VIN?
					</p>

					<FormGroup>
						<Label for="voidReason">Reason for Void <span className="text-danger">*</span></Label>
						<Input
							type="textarea"
							id="voidReason"
							rows="3"
							value={voidReason}
							onChange={(e) => setVoidReason(e.target.value)}
							placeholder="Enter reason for voiding the sale..."
						/>
					</FormGroup>

					<Row>
						<Col className="text-center">
							<Button
								color="primary"
								className="me-2"
								onClick={handleVoidSale}
							>
								YES
							</Button>
							<Button
								color="secondary"
								onClick={handleCancelModal}
							>
								Cancel
							</Button>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</Modal>
	)
}

export default VoidSaleModal
